import { getRouter, RouterIds } from '@online-webinar/router';
import { updateRoute as WebinarIdAChar123AuthorizationCodeChar125UpdateRoute } from './routes/$webinarId.a.{-$authorizationCode}';
import { updateRoute as WebinarIdAnalyticsUpdateRoute } from './routes/$webinarId.analytics';
import { updateRoute as WebinarIdAttachmentsUpdateRoute } from './routes/$webinarId.attachments';
import { updateRoute as WebinarIdBLinkCodeUpdateRoute } from './routes/$webinarId.b.$linkCode';
import { updateRoute as WebinarIdBroadcastUpdateRoute } from './routes/$webinarId.broadcast';
import { updateRoute as WebinarIdChaptersUpdateRoute } from './routes/$webinarId.chapters';
import { updateRoute as WebinarIdChatMessagesUpdateRoute } from './routes/$webinarId.chat-messages';
import { updateRoute as WebinarIdChatSettingsUpdateRoute } from './routes/$webinarId.chat-settings';
import { updateRoute as WebinarIdContentUpdateRoute } from './routes/$webinarId.content';
import { updateRoute as WebinarIdDeleteUpdateRoute } from './routes/$webinarId.delete';
import { updateRoute as WebinarIdEditUpdateRoute } from './routes/$webinarId.edit';
import { updateRoute as WebinarIdEditExamUpdateRoute } from './routes/$webinarId.edit-exam';
import { updateRoute as WebinarIdEditSubtitlesUpdateRoute } from './routes/$webinarId.edit-subtitles';
import { updateRoute as WebinarIdEditSurveyUpdateRoute } from './routes/$webinarId.edit-survey';
import { updateRoute as WebinarIdEditVideoUpdateRoute } from './routes/$webinarId.edit-video';
import { updateRoute as WebinarIdExamUpdateRoute } from './routes/$webinarId.exam';
import { updateRoute as WebinarIdExamResultUpdateRoute } from './routes/$webinarId.exam-result';
import { updateRoute as WebinarIdFollowUpFollowUpIdIndexUpdateRoute } from './routes/$webinarId.follow-up.$followUpId.index';
import { updateRoute as WebinarIdFollowUpFollowUpIdProcessedUpdateRoute } from './routes/$webinarId.follow-up.$followUpId.processed';
import { updateRoute as WebinarIdFollowUpIndexUpdateRoute } from './routes/$webinarId.follow-up.index';
import { updateRoute as WebinarIdForgotPasswordUpdateRoute } from './routes/$webinarId.forgot-password';
import { updateRoute as WebinarIdIndexUpdateRoute } from './routes/$webinarId.index';
import { updateRoute as WebinarIdInsightsUpdateRoute } from './routes/$webinarId.insights';
import { updateRoute as WebinarIdInterestedAccountsUpdateRoute } from './routes/$webinarId.interested-accounts';
import { updateRoute as WebinarIdInvitesImportUpdateRoute } from './routes/$webinarId.invites.import';
import { updateRoute as WebinarIdInvitesIndexUpdateRoute } from './routes/$webinarId.invites.index';
import { updateRoute as WebinarIdLiveParticipantsUpdateRoute } from './routes/$webinarId.live-participants';
import { updateRoute as WebinarIdMarketingIdUpdateRoute } from './routes/$webinarId.marketing.$id';
import { updateRoute as WebinarIdMarketingIdSelectListUpdateRoute } from './routes/$webinarId.marketing.$id.select-list';
import { updateRoute as WebinarIdMarketingImportUpdateRoute } from './routes/$webinarId.marketing.import';
import { updateRoute as WebinarIdMarketingIndexUpdateRoute } from './routes/$webinarId.marketing.index';
import { updateRoute as WebinarIdLiveTranscribeUpdateRoute } from './routes/$webinarId.live-transcribe';
import { updateRoute as WebinarIdLoginUpdateRoute } from './routes/$webinarId.login';
import { updateRoute as WebinarIdMLinkCodeUpdateRoute } from './routes/$webinarId.m.$linkCode';
import { updateRoute as WebinarIdOLinkCodeUpdateRoute } from './routes/$webinarId.o.$linkCode';
import { updateRoute as WebinarIdOnDemandUpdateRoute } from './routes/$webinarId.on-demand';
import { updateRoute as WebinarIdOnDemandParticipantsUpdateRoute } from './routes/$webinarId.on-demand-participants';
import { updateRoute as WebinarIdPollResultUpdateRoute } from './routes/$webinarId.poll-result';
import { updateRoute as WebinarIdPollsPollIdWeightingUpdateRoute } from './routes/$webinarId.polls.$pollId.weighting';
import { updateRoute as WebinarIdPollsIndexUpdateRoute } from './routes/$webinarId.polls.index';
import { updateRoute as WebinarIdRegisterUpdateRoute } from './routes/$webinarId.register';
import { updateRoute as WebinarIdSLinkCodeUpdateRoute } from './routes/$webinarId.s.$linkCode';
import { updateRoute as WebinarIdSecurityUpdateRoute } from './routes/$webinarId.security';
import { updateRoute as WebinarIdShareUpdateRoute } from './routes/$webinarId.share';
import { updateRoute as WebinarIdSlideControllerUpdateRoute } from './routes/$webinarId.slide-controller';
import { updateRoute as WebinarIdSlideDeckUpdateRoute } from './routes/$webinarId.slide-deck';
import { updateRoute as WebinarIdSlideViewerUpdateRoute } from './routes/$webinarId.slide-viewer';
import { updateRoute as WebinarIdSurveyUpdateRoute } from './routes/$webinarId.survey';
import { updateRoute as WebinarIdSurveyResultUpdateRoute } from './routes/$webinarId.survey-result';
import { updateRoute as WebinarIdWLinkCodeUpdateRoute } from './routes/$webinarId.w.$linkCode';
import { updateRoute as WebinarIdWatchUpdateRoute } from './routes/$webinarId.watch';
import { updateRoute as rootUpdateRoute } from './routes/__root';
import { updateRoute as AccessDeniedUpdateRoute } from './routes/access-denied';
import { updateRoute as AccountManagerInviteInviteCodeUpdateRoute } from './routes/account-manager-invite.$inviteCode';
import { updateRoute as AccountTabUpdateRoute } from './routes/account.$tab';
import { updateRoute as CreateUpdateRoute } from './routes/create';
import { updateRoute as ForgotPasswordUpdateRoute } from './routes/forgot-password';
import { updateRoute as IndexUpdateRoute } from './routes/index';
import { updateRoute as LoginUpdateRoute } from './routes/login';
import { updateRoute as ManageAccountInvitesImportUpdateRoute } from './routes/manage.account-invites.import';
import { updateRoute as ManageAccountInvitesIndexUpdateRoute } from './routes/manage.account-invites.index';
import { updateRoute as ManageBlacklistUpdateRoute } from './routes/manage.blacklist';
import { updateRoute as ManageChatLinkDomainsUpdateRoute } from './routes/manage.chat-link-domains';
import { updateRoute as ManageEmailListsIdUpdateRoute } from './routes/manage.email-lists.$id';
import { updateRoute as ManageEmailListsImportUpdateRoute } from './routes/manage.email-lists.import';
import { updateRoute as ManageEmailListsIndexUpdateRoute } from './routes/manage.email-lists.index';
import { updateRoute as ManageEmailStyleUpdateRoute } from './routes/manage.email-style';
import { updateRoute as ManageEmailTemplateTemplateTypeSubTemplateUpdateRoute } from './routes/manage.email-template.$templateType.$subTemplate';
import { updateRoute as ManageEmailTemplateTemplateTypeIndexUpdateRoute } from './routes/manage.email-template.$templateType.index';
import { updateRoute as ManageEmailTemplateIndexUpdateRoute } from './routes/manage.email-template.index';
import { updateRoute as ManageIndexUpdateRoute } from './routes/manage.index';
import { updateRoute as ManageTranslationUpdateRoute } from './routes/manage.translation';
import { updateRoute as ManageUsageStatisticsUpdateRoute } from './routes/manage.usage-statistics';
import { updateRoute as ManageWebinarDurationUpdateRoute } from './routes/manage.webinar-duration';
import { updateRoute as NotFoundUpdateRoute } from './routes/not-found';
import { updateRoute as OnDemandUpdateRoute } from './routes/on-demand';
import { updateRoute as OrganizedTabUpdateRoute } from './routes/organized.$tab';
import { updateRoute as OrganizedIndexUpdateRoute } from './routes/organized.index';
import { updateRoute as RAccountInviteIdUpdateRoute } from './routes/r.$accountInviteId';
import { updateRoute as RegisterUpdateRoute } from './routes/register';
import { updateRoute as ResetPasswordResetCodeUpdateRoute } from './routes/reset-password.$resetCode';
import { updateRoute as SiteDotcssUpdateRoute } from './routes/site[.]css';
import { updateRoute as SwitchAccountUpdateRoute } from './routes/switch-account';
import { updateRoute as TestSuiteCameraUpdateRoute } from './routes/test-suite.camera';
import { updateRoute as TestSuiteIndexUpdateRoute } from './routes/test-suite.index';
import { updateRoute as TestSuiteLineUpdateRoute } from './routes/test-suite.line';
import { updateRoute as ThemeDotcssUpdateRoute } from './routes/theme[.]css';
import { updateRoute as UnsubscribeTokenUpdateRoute } from './routes/unsubscribe.$token';
import { updateRoute as UpcomingUpdateRoute } from './routes/upcoming';
import { updateRoute as VerifyAccountVerificationCodeUpdateRoute } from './routes/verify-account.$verificationCode';
import { updateRoute as WLinkCodeUpdateRoute } from './routes/w.$linkCode';

export const updateRoutes = {
    __root__: rootUpdateRoute,
    '/': IndexUpdateRoute,
    '/access-denied': AccessDeniedUpdateRoute,
    '/create': CreateUpdateRoute,
    '/forgot-password': ForgotPasswordUpdateRoute,
    '/login': LoginUpdateRoute,
    '/not-found': NotFoundUpdateRoute,
    '/on-demand': OnDemandUpdateRoute,
    '/register': RegisterUpdateRoute,
    '/site.css': SiteDotcssUpdateRoute,
    '/switch-account': SwitchAccountUpdateRoute,
    '/test-suite/': TestSuiteIndexUpdateRoute,
    '/test-suite/camera': TestSuiteCameraUpdateRoute,
    '/test-suite/line': TestSuiteLineUpdateRoute,
    '/theme.css': ThemeDotcssUpdateRoute,
    '/upcoming': UpcomingUpdateRoute,
    '/$webinarId/attachments': WebinarIdAttachmentsUpdateRoute,
    '/$webinarId/broadcast': WebinarIdBroadcastUpdateRoute,
    '/$webinarId/chapters': WebinarIdChaptersUpdateRoute,
    '/$webinarId/chat-messages': WebinarIdChatMessagesUpdateRoute,
    '/$webinarId/chat-settings': WebinarIdChatSettingsUpdateRoute,
    '/$webinarId/content': WebinarIdContentUpdateRoute,
    '/$webinarId/delete': WebinarIdDeleteUpdateRoute,
    '/$webinarId/edit': WebinarIdEditUpdateRoute,
    '/$webinarId/edit-exam': WebinarIdEditExamUpdateRoute,
    '/$webinarId/edit-subtitles': WebinarIdEditSubtitlesUpdateRoute,
    '/$webinarId/edit-survey': WebinarIdEditSurveyUpdateRoute,
    '/$webinarId/edit-video': WebinarIdEditVideoUpdateRoute,
    '/$webinarId/exam': WebinarIdExamUpdateRoute,
    '/$webinarId/exam-result': WebinarIdExamResultUpdateRoute,
    '/$webinarId/forgot-password': WebinarIdForgotPasswordUpdateRoute,
    '/$webinarId/insights': WebinarIdInsightsUpdateRoute,
    '/$webinarId/interested-accounts': WebinarIdInterestedAccountsUpdateRoute,
    '/$webinarId/live-participants': WebinarIdLiveParticipantsUpdateRoute,
    '/$webinarId/live-transcribe': WebinarIdLiveTranscribeUpdateRoute,
    '/$webinarId/login': WebinarIdLoginUpdateRoute,
    '/$webinarId/on-demand': WebinarIdOnDemandUpdateRoute,
    '/$webinarId/on-demand-participants': WebinarIdOnDemandParticipantsUpdateRoute,
    '/$webinarId/poll-result': WebinarIdPollResultUpdateRoute,
    '/$webinarId/register': WebinarIdRegisterUpdateRoute,
    '/$webinarId/security': WebinarIdSecurityUpdateRoute,
    '/$webinarId/share': WebinarIdShareUpdateRoute,
    '/$webinarId/slide-controller': WebinarIdSlideControllerUpdateRoute,
    '/$webinarId/slide-deck': WebinarIdSlideDeckUpdateRoute,
    '/$webinarId/slide-viewer': WebinarIdSlideViewerUpdateRoute,
    '/$webinarId/survey': WebinarIdSurveyUpdateRoute,
    '/$webinarId/survey-result': WebinarIdSurveyResultUpdateRoute,
    '/$webinarId/watch': WebinarIdWatchUpdateRoute,
    '/$webinarId/analytics': WebinarIdAnalyticsUpdateRoute,
    '/account-manager-invite/$inviteCode': AccountManagerInviteInviteCodeUpdateRoute,
    '/account/$tab': AccountTabUpdateRoute,
    '/manage/blacklist': ManageBlacklistUpdateRoute,
    '/manage/chat-link-domains': ManageChatLinkDomainsUpdateRoute,
    '/manage/email-style': ManageEmailStyleUpdateRoute,
    '/manage/translation': ManageTranslationUpdateRoute,
    '/manage/usage-statistics': ManageUsageStatisticsUpdateRoute,
    '/manage/webinar-duration': ManageWebinarDurationUpdateRoute,
    '/organized/$tab': OrganizedTabUpdateRoute,
    '/r/$accountInviteId': RAccountInviteIdUpdateRoute,
    '/reset-password/$resetCode': ResetPasswordResetCodeUpdateRoute,
    '/unsubscribe/$token': UnsubscribeTokenUpdateRoute,
    '/verify-account/$verificationCode': VerifyAccountVerificationCodeUpdateRoute,
    '/$webinarId/': WebinarIdIndexUpdateRoute,
    '/manage/': ManageIndexUpdateRoute,
    '/organized/': OrganizedIndexUpdateRoute,
    '/$webinarId/a/{-$authorizationCode}': WebinarIdAChar123AuthorizationCodeChar125UpdateRoute,
    '/$webinarId/b/$linkCode': WebinarIdBLinkCodeUpdateRoute,
    '/$webinarId/invites/import': WebinarIdInvitesImportUpdateRoute,
    '/$webinarId/m/$linkCode': WebinarIdMLinkCodeUpdateRoute,
    '/$webinarId/o/$linkCode': WebinarIdOLinkCodeUpdateRoute,
    '/$webinarId/s/$linkCode': WebinarIdSLinkCodeUpdateRoute,
    '/$webinarId/w/$linkCode': WebinarIdWLinkCodeUpdateRoute,
    '/manage/account-invites/import': ManageAccountInvitesImportUpdateRoute,
    '/manage/email-lists/import': ManageEmailListsImportUpdateRoute,
    '/manage/email-lists/$id': ManageEmailListsIdUpdateRoute,
    '/$webinarId/marketing/import': WebinarIdMarketingImportUpdateRoute,
    '/$webinarId/marketing/$id': WebinarIdMarketingIdUpdateRoute,
    '/$webinarId/marketing/$id/select-list': WebinarIdMarketingIdSelectListUpdateRoute,
    '/$webinarId/marketing/': WebinarIdMarketingIndexUpdateRoute,
    '/$webinarId/follow-up/': WebinarIdFollowUpIndexUpdateRoute,
    '/$webinarId/invites/': WebinarIdInvitesIndexUpdateRoute,
    '/$webinarId/polls/': WebinarIdPollsIndexUpdateRoute,
    '/manage/account-invites/': ManageAccountInvitesIndexUpdateRoute,
    '/manage/email-lists/': ManageEmailListsIndexUpdateRoute,
    '/manage/email-template/': ManageEmailTemplateIndexUpdateRoute,
    '/$webinarId/follow-up/$followUpId/processed': WebinarIdFollowUpFollowUpIdProcessedUpdateRoute,
    '/$webinarId/polls/$pollId/weighting': WebinarIdPollsPollIdWeightingUpdateRoute,
    '/manage/email-template/$templateType/$subTemplate': ManageEmailTemplateTemplateTypeSubTemplateUpdateRoute,
    '/$webinarId/follow-up/$followUpId/': WebinarIdFollowUpFollowUpIdIndexUpdateRoute,
    '/manage/email-template/$templateType/': ManageEmailTemplateTemplateTypeIndexUpdateRoute,
    '/w/$linkCode': WLinkCodeUpdateRoute
    // '/health' is a server-only route (returns plain-text "OK"); it has no client component to override.
} as const satisfies Record<Exclude<RouterIds, '/$webinarId' | '/test-suite' | '/health'>, (router: ReturnType<typeof getRouter>) => void>;
